import * as types from "./mutationTypes";

export default {
  [types.SET_LOOPS](state, { loops }) {
    state.loops = loops;
  },
  [types.CLEAR_QUERY_PARAMS](state) {
    state.queryParams = {};
  },
  [types.SET_QUERY_PARAMS](state, { params }) {
    state.queryParams = {
      ...state.queryParams,
      ...params
    };
  },
  [types.SET_LOOP_INTERACTIONS](state, { loopInteractions }) {
    state.loopInteractions = loopInteractions;
  },
  [types.SET_LOOP](state, { loop }) {
    state.loop = loop;
  },
  [types.SET_INDICATORS](state, { indicators }) {
    state.indicators = indicators;
  },
  [types.CLEAR_LOOP_STATE](state) {
    state.loops = [];
    state.queryParams = {};
    state.loopInteractions = 0;
    state.loop = {};
    state.indicators = null;
  },
  [types.CLEAR_LOOP](state) {
    state.loop = {};
  },
  [types.SET_NAME](state, { name }) {
    state.loop.name = name;
  },
  [types.SET_AUTO](state, { auto }) {
    state.loop.auto = auto;
  },
  [types.SET_FINISH_LOOP_TEMPLATE](state, { templateUUID }) {
    state.loop.finish_loop_template_uuid = templateUUID;
  },
  [types.SET_PRIORITY](state, { priority }) {
    state.loop.priority = priority;
  },
  [types.SET_SEGMENT](state, { segmentUUID }) {
    state.loop.segment_uuid = segmentUUID;
  },
  [types.SET_SEND_FINISH_EMAIL](state, { sendFinishEmail }) {
    state.loop.send_finish_email = sendFinishEmail;
  },
  [types.SET_SENDER_NAME](state, { senderName }) {
    state.loop.sender_name = senderName;
  },
  [types.SET_TEAMS](state, { teams }) {
    state.loop.teams = teams;
  }
};
